import React from "react";
import "./Donationdetails.css";
import { FiTrash } from "react-icons/fi";
import junk from "../../Assests/service6.webp";

const Donationdetails = () => {
  return (
    <section className="Donationdetails-section">
      <div className="Donationdetails-container">
        {/* Content Column */}
        <div className="Donationdetails-content">
          <div className="Donationdetails-content-header">
            <div className="Donationdetails-service-icons">
              <FiTrash size={32} />
            </div>
            <h1 className="Donationdetails-service-title">
              <span className="Donationdetails-title-accent">Donations </span> & Recycling
            </h1>
          </div>

          <p className="Donationdetails-service-description">
            Donating and recycling items is one of the easiest ways to reduce waste while helping
            the community. Our team makes the process simple by picking up furniture, clothing,
            appliances, and household goods that are still in usable condition. We sort and deliver
            these items to local charities, shelters, and donation centers—ensuring they benefit
            those who need them most.
          </p>

          <p className="Donationdetails-service-description">
            For items that cannot be donated, we recycle materials whenever possible, including
            metals, electronics, and certain plastics. Everything else is disposed of responsibly,
            keeping environmental impact to a minimum. With our donation and recycling service,
            you can declutter your home or office while making a positive difference in your
            community and for the planet.
          </p>

          <div className="Donationdetails-cta-group">
            <a
              href="https://app.squareup.com/appointments/book/41vplmwf0luh01/LTHMTFD90TMRT/start"
              className="Donationdetails-primary-cta"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule Your Pickup
              <span className="Donationdetails-cta-arrow">→</span>
            </a>
          </div>
        </div>

        {/* Image Column */}
        <div className="Donationdetails-image">
          <div className="Donationdetails-image-wrapper">
            <img
              src={junk}
              alt="Team sorting donations and recycling items responsibly"
              className="Donationdetails-main-image"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Donationdetails;
